import { render, staticRenderFns } from "./PopoverDownload.vue?vue&type=template&id=521a549b"
import script from "./PopoverDownload.vue?vue&type=script&lang=js"
export * from "./PopoverDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports